import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IClinicMajor } from 'interfaces'
import { IGroupService } from 'pages/menuGroupService/interfaces'
import { RootState } from 'store'

export interface IServiceState {
  services: Array<IGroupService>
  isGetServiceNew: boolean
  majors: Array<IClinicMajor>
}

const initialState: IServiceState = {
  services: [],
  majors: [],
  isGetServiceNew: false
}

export const serviceSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    setMajorsAction: (
      state: IServiceState,
      action: PayloadAction<Array<IClinicMajor>>
    ) => {
      state.majors = action.payload
    },
    setServicesAction: (state: IServiceState, action?: any) => {
      state.services = action.payload
      state.isGetServiceNew = true
    },
    resetServiceStateAction: () => initialState
  }
})

export const { setMajorsAction, setServicesAction, resetServiceStateAction } =
  serviceSlice.actions
export const serviceSelector = (state: RootState) => state.serviceReducer
export default serviceSlice.reducer
